<template>
  <div class="anchor-js-container">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import AnchorJS from 'anchor-js'

let selectors = [
  '.c-content__article h2',
  '.c-content__article h3',
  '.c-content__article h4',
  '.c-content__article h5',
  '.c-content__article h6',

  '.c-content__event h2',
  '.c-content__event h3',
  '.c-content__event h4',
  '.c-content__event h5',
  '.c-content__event h6',

  '.c-content__collection h2',
  '.c-content__collection h3',
  '.c-content__collection h4',
  '.c-content__collection h5',
  '.c-content__collection h6'
]

function removeEmptySelectors (selectors: string[]) {
  selectors.forEach(selector => {
    const elements = document.querySelectorAll(selector)
    elements.forEach(element => {
      if (!element.hasChildNodes()) {
        const index = selectors.indexOf(selector)
        if (index !== -1) {
          selectors.splice(index, 1)
        }
      }
    })
  })
  return selectors
}

onMounted(() => {
  const anchors = new AnchorJS()
  anchors.options = {
    icon: ''
  }

  selectors = removeEmptySelectors(selectors)

  anchors.add(selectors.join(', '))
})
</script>

<style scoped lang="scss">
.anchor-js-container ::v-deep(a.anchorjs-link:not(.c-button)) {
  text-decoration: none;
  display: inline-block;
  background: url("/static/icons/link.svg") no-repeat;
  margin-left: 4px !important;
  width: 24px;
  height: 24px;
  transform: scale(0.8);
  &:hover {
    text-decoration: none;
  }
}
</style>
